export default __webpack_public_path__ + "static/404-dd001600e85a581d2233d77b3cdfc715.webp";